const INITIAL_STATE = {
  status: null,
  hasWifi: null,
};

module.exports = function NetworkReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'NETWORK_STATUS': {
      if (state.status === action.status) {
        return state;
      }
      const { status } = action;
      const hasWifi = status && status.toLowerCase() === 'wifi';
      return {
        ...state,
        status,
        hasWifi,
      };
    }

    default: {
      return state;
    }
  }
};
